/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getHelpArticleCashDotApp} from '../api'

 export const useQueryGetHelpArticleCashDotApp = createReactQueryHook('getHelpArticleCashDotApp', getHelpArticleCashDotApp)
